export { I18nProvider, useT, useLocale, format } from './I18nProvider'
export { LocalizedProcessingBadge } from './LocalizedProcessingBadge'
export { DEFAULT_LOCALE, LOCALES } from './locale'
export type { Locale } from './locale'
export type { Translations } from './ru'

import { useT } from './I18nProvider'

/**
 * Locale-aware byte formatter for UI display.
 *
 * Returns a function that formats bytes using the current locale's unit names
 * (МиБ/КиБ in RU, MiB/KiB in EN).
 */
export function useFormatBytes(): (bytes: number) => string {
  const t = useT()
  return (bytes: number) => {
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(2)} ${t.units.mib}`
    }
    return `${(bytes / 1024).toFixed(1)} ${t.units.kib}`
  }
}
